import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'primeiroParagrafo',
})
export class RetornaPrimeiroParagrafo implements PipeTransform {
  selecionaParagrafo = /([A-Z].*)\n/;
  paragrafo: any;
  transform(value: any) {
    const match = value.match(/([A-Z].*?)\n\n/);
    return match[0];
  }
}
